<template>
    <v-layout wrap>
        <v-navigation-drawer absolute permanent right style="width: 600px;">
            <!--  상단 이미지 및 선택 타이틀 이름-->
            <v-list class="pa-1">
                <v-list-item>
                    <v-tabs v-model="tab">
                        <v-tab v-if="copyValue._instanceInfo.length > 0">
                            <v-list-item-title>Instance Info</v-list-item-title>
                        </v-tab>
                        <v-tab v-if="copyValue._instanceInfo.length > 0">
                            <v-list-item-title>Actions</v-list-item-title>
                        </v-tab>
                        <v-tab v-for="tab in tabs" :key="tab" :id="tab.toLowerCase() + _uid">
                            <v-list-item-title>{{ tab }}</v-list-item-title>
                        </v-tab>
                    </v-tabs>
                    
                    <v-btn icon @click.native="closePanel()">
                        <v-icon color="grey lighten-1">mdi-close</v-icon>
                    </v-btn>
                </v-list-item>
            </v-list>

            <v-list class="pt-0" dense flat>
                <v-divider></v-divider>
                <div v-if="(copyValue._instanceInfo.length < 1 && tab == 0) || (copyValue._instanceInfo.length > 0 && tab == 2)" style="margin-top: 10px">
                    <v-card flat>
                        <v-card-text>
                            <v-text-field
                                    v-model="copyValue.name"
                                    label="Pool/Lane (Role) Name"
                                    autofocus
                            ></v-text-field>
                            
                            <v-radio-group v-model="isRoleDef" row>
                                <v-radio
                                        id="roleDef"
                                        name="roleDef"
                                        value="Human"
                                        label="Human"
                                ></v-radio>
                                <v-radio
                                        id="roleDef"
                                        name="roleDef"
                                        value="System"
                                        label="System"
                                ></v-radio>
                            </v-radio-group>
                            
                            <div v-if="isRoleDef=='Human'">
                                <v-radio-group v-model="isRoleResolution" row style="margin-top: 0px !important;">
                                    <v-radio
                                            id="roleResolution"
                                            name="roleResolution"
                                            value="null"
                                            label="None"
                                            style="margin-right: 8px !important; font-size: 15px;"
                                    ></v-radio>
                                    <v-radio
                                            id="roleResolution"
                                            name="roleResolution"
                                            value="org.uengine.five.overriding.IAMRoleResolutionContext"
                                            label="Role Resolution By IAM Scope"
                                            style="margin-right: 8px !important; font-size: 15px;"
                                    ></v-radio>
                                    <v-radio
                                            id="roleResolution"
                                            name="roleResolution"
                                            value="org.uengine.kernel.DirectRoleResolutionContext"
                                            label="Role Resolution By Direct user"
                                            style="margin-right: 8px !important; font-size: 15px;"
                                    ></v-radio>
                                </v-radio-group>
                                
                                <v-text-field
                                        v-if="copyValue.roleResolutionContext && 
                                            copyValue.roleResolutionContext._type == 'org.uengine.five.overriding.IAMRoleResolutionContext'"
                                        v-model="copyValue.roleResolutionContext.scope"
                                        label="Scope Name"
                                ></v-text-field>

                                <v-text-field 
                                        v-if="copyValue.roleResolutionContext && 
                                            copyValue.roleResolutionContext._type == 'org.uengine.kernel.DirectRoleResolutionContext'"
                                        v-model="copyValue.roleResolutionContext.endpoint"
                                        label="User ID"
                                ></v-text-field>
                            </div>

                            <div v-if="isRoleDef=='System'">
                                <v-select
                                        v-model="copyValue.name"
                                        :items="serviceIdList"
                                        label="Select serviceId from eureka"
                                ></v-select>
                            </div>
                        </v-card-text>
                    </v-card>
                </div>
                <div v-if="(copyValue._instanceInfo.length < 1 && tab == 1) || (copyValue._instanceInfo.length > 0 && tab == 3)">
                    <v-card flat>
                        <v-card-text>
                            <v-row>
                                <v-col cols="6" class="py-0">
                                    <v-text-field
                                            label="x"
                                            v-model="x"
                                            type="number"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="6" class="py-0">
                                    <v-text-field
                                            label="y"
                                            v-model="y"
                                            type="number"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="6" class="py-0">
                                    <v-text-field
                                            label="width"
                                            v-model="width"
                                            type="number"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="6" class="py-0">
                                    <v-text-field
                                            label="height"
                                            v-model="height"
                                            type="number"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-text-field
                                    v-for="(item, idx) in style" :key="idx"
                                    v-model="style[idx].value"
                                    :label="item.key"
                            ></v-text-field>
                        </v-card-text>
                    </v-card>
                </div>
                <div v-if="copyValue._instanceInfo && copyValue._instanceInfo.length > 0 && tab == 0">
                    <v-card flat>
                        <v-card-text>
                            <v-simple-table>
                                <template v-slot:default>
                                    <thead>
                                        <tr>
                                            <th class="text-left">Key</th>
                                            <th class="text-left">Value</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(row, index) in copyValue._instanceInfo" :key="index">
                                            <td>{{ index }}</td>
                                            <td>{{ copyValue._instanceInfo[index] }}</td>
                                        </tr>
                                    </tbody>
                                </template>
                            </v-simple-table>
                        </v-card-text>
                    </v-card>
                </div>
                <div v-if="copyValue._instanceInfo && copyValue._instanceInfo.length > 0 && tab == 1">
                    <v-card flat>
                        <v-card-text>
                            <v-btn color="primary" @click="backToHere">Back to here</v-btn>
                        </v-card-text>
                    </v-card>
                </div>
            </v-list>

        </v-navigation-drawer>
    </v-layout>
</template>

<script>
    import BpmnPropertyPanel from '../BpmnPropertyPanel'

    export default {
        mixins: [BpmnPropertyPanel],
        name: 'bpmn-role-panel',
        props: {
            serviceIds: Array,
            roleDef: String,
            roleResolution: Boolean,
        },
        data() {
            return {
                tabs: [ 'Properties', 'Visual' ],
                tab: null,
            }
        },
        created: function () {
        },
        mounted: function () {
        },
        computed: {
            serviceIdList: {
                get() {
                    return this.serviceIds
                },
                set(val) {
                    this.$emit('updateServiceIds', val);
                }
            },
            isRoleDef: {
                get() {
                    return this.roleDef
                },
                set(val) {
                    this.$emit('updateRoleDef', val);
                }
            },
            isRoleResolution: {
                get() {
                    return this.roleResolution
                },
                set(val) {
                    this.$emit('updateRoleResolution', val);
                }
            }
        },
        watch: {
        },
        methods: {
            closePanel() {
                this.navigationDrawer = false;
                this.$emit('updateServiceIds', this.serviceIds);
                this.$emit('updateRoleDef', this.roleDef);
                this.$emit('updateRoleResolution', this.roleResolution);
                this.$emit('close');
            },
        }
    }
</script>


<style lang="scss" rel="stylesheet/scss">

</style>

